<template>
    <div id="magic-zoom">
        <div itemscope itemtype="http://schema.org/Thing">
            <div class="ItemImgWrap justify-content-center bg-white border">
              <div v-if="schuhsize" class="single-shoesize" v-tooltip data-toggle="tooltip" data-placement="top" data-html="true" title="<div class'text-left'><p class='text-left'>Schuhweite F: Schuhe für normal schlanke Füße</p><p class='text-left'>Schuhweite G: Schuhe mit Komfortweite für normale Füße</p><p class='text-left'>Schuhweite H: Schuhe mit Bequemweite für etwas kräftigere Füße</p><p class='text-left'>Schuhweite J: Schuhe für Füße mit Überweite</p><p class='text-left'>Schuhweite K: Schuhe mit Spezialweite für sehr kräftige Füße</p><p class='text-left'>Schuhweite M: Schuhe für Füße mit Extra-Überweite</p></div>">{{ schuhsize }}</div>
              <template v-if="variationSelected.selected">
                <csaddtolist :variation-id="magiczoom.variation.id" :current-item-id="magiczoom.item.id" :quantity="variationSelected.quantity"></csaddtolist>
              </template>
              <template v-else>
                <csaddtolist :variation-id="0" :current-item-id="magiczoom.item.id" :quantity="variationSelected.quantity"></csaddtolist>
              </template>
                <button class="zoom-xs-left d-lg-none" @click="prevNext('left')"  v-if="magiczoom.images.all.length > 1">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                </button>
                <!-- <add-to-wish-list :variation-id="magiczoom.variation.id"></add-to-wish-list> -->
                <a :href="magiczoom.images | itemImages('url') | itemImage" id="ItemImgZoom" class="MagicZoomPlus flex-fill d-flex align-items-start justify-content-center"
                   :data-mobile-options="'zoomMode:off; lazyZoom: true; textTouchZoomHint:'+  $translate('Bigtex5::Template.singleZoomHint') +'; textClickZoomHint: '+ $translate('Bigtex5::Template.singleZoomHint2') +'; textExpandHint: '+$translate('Bigtex5::Template.singleZoomHint')"
                   :data-options="'lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:'+$translate('Bigtex5::Template.singleZoomHint3')+'; textExpandHint:'+ $translate('Bigtex5::Template.singleZoomHint3')+'; zoomPosition: #zoom-placeholder;'">
                    <img  class="img-fluid" :src="magiczoom.images | itemImages('urlMiddle') | itemImage" itemprop="image" :alt="magiczoom.texts.name1" :title="magiczoom.texts.name1">

                    <template v-if="blackday.tag.length > 0 && blackday.active" >
                      <div class="action action-3" >
                        <div class="blackday">
                          <i class="fa fa-fire" aria-hidden="true"></i>
                          {{ blackday.tag[0].names.name }}
                        </div>
                      </div>
                    </template>
                    <div :class="'action action-'+magiczoom.item.storeSpecial.id" v-if="magiczoom.item.storeSpecial" :style="{ top: blackday.tag.length > 0 && blackday.active ? '40px' : '0px' }">
                        <span v-html="magiczoom.item.storeSpecial.names.name" v-if="magiczoom.item.storeSpecial.id != '1' "></span>
                        <template v-if="magiczoom.prices.rrp != null">
                          <span v-if="magiczoom.prices.rrp.price.value >  magiczoom.prices.default.price.value">
                              -{{  (((magiczoom.prices.rrp.price.value - magiczoom.prices.default.price.value) / magiczoom.prices.rrp.price.value)*100) | numberFormat(0) }}%
                          </span>
                        </template>
                    </div>

                </a>
                <button class="zoom-xs-right d-lg-none" @click="prevNext('right')" v-if="magiczoom.images.all.length > 1">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                </button>
                <template v-if="magiczoom.images.all.length > 1">
                  <div class="magic-more-images d-none d-lg-block" v-if="magiczoom.images.all.length >= 4">
                    <div class="d-flex align-items-center">
                      <div @click="slidePrev" class="text-center fa-lg mb-2 cursor" v-if="magiczoom.images.all.length > 4">
                        <i class="fa fa-angle-left"></i>
                      </div>
                      <hooper class="d-none d-lg-block" :vertical="false" :infiniteScroll="false" :itemsToSlide="4" :itemsToShow="4" :trimWhiteSpace="true" ref="carousel">
                        <slide v-if="ytvideo !=''">
                          <a class="border video d-flex mb-2 videoImage cursor hooper-box" @click="showVideo()" @mouseover.once="$store.dispatch('loadComponent', 'yt-video')">
                            <i class="fa fa-play-circle-o" v-if="!loading"></i>
                            <i class="fa fa-circle-o-notch fa-spin" v-else></i>
                          </a>
                        </slide>
                        <slide v-for="(imagePreview, index) in magiczoom.images.all">
                          <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="border d-block hooper-box" :class="{'mz-thumb-selected' : index == 0 }">
                            <img
                                :alt="'imagePreview-'+index"
                                :data-src="imagePreview.url"
                                :src="imagePreview.urlSecondPreview">
                          </a>
                        </slide>
                      </hooper>
                      <div @click="slideNext" class="text-center fa-lg cursor" v-if="magiczoom.images.all.length > 4">
                        <i class="fa fa-angle-right"></i>
                      </div>
                    </div>
                  </div>
                  <div class="magic-more-images d-none d-lg-block" v-else>
                    <div class="d-flex">
                      <template v-if="ytvideo !=''">
                        <a class="border video d-flex mb-2 videoImage" @click="showVideo()" @mouseover.once="$store.dispatch('loadComponent', 'yt-video')">
                          <i class="fa fa-play-circle-o" v-if="!loading"></i>
                          <i class="fa fa-circle-o-notch fa-spin" v-else></i>
                        </a>
                      </template>
                      <template v-for="(imagePreview, index) in magiczoom.images.all">
                        <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="mb-2 border">
                          <img
                              :alt="'imagePreview-'+index"
                              :data-src="imagePreview.url"
                              :src="imagePreview.urlSecondPreview">
                        </a>
                      </template>
                    </div>
                  </div>
                </template>
            </div>
            <div class="zoom-navigation-dots d-md-none">
            </div>
        </div>
    </div>
</template>

<script>
    import { Hooper, Slide  } from 'hooper';
    export default
    {
        components: { Hooper, Slide },
        props:
        {
            template:
            {
                type: String,
                default: "#vue-magic-zoom"
            }
        },
        inject:
        {
            itemId:
            {
                default: null
            }
        },
        created()
        {
          this.shoesizes();
        },
        data: function()
        {
            return {
                onloadVarId: this.currentVariation().variation.id,
                dotsCount: 0,
                loading:false,
                youtubeid:'',
                schuhsize:null
            }
        },
        methods:
        {
            prevNext(direction)
            {
                if(direction=="left")
                {
                    MagicZoom.prev('ItemImgZoom');
                }
                else if(direction=="right")
                {
                    MagicZoom.next('ItemImgZoom');
                }
                else
                {
                 /*   console.log('unknown direction');*/
                }

            },
            showVideo:function()
            {
              //set timeout
                setTimeout(function () {
                    $('#video-modal').modal('show')
                },500)
                vueEventHub.$emit("showvideo",true);
            },
            shoesizes: function()
            {
              let _self   = this;
              let current = this.currentVariation()
              for(let i = 0; i < current.properties.length; i++)
              {
                let prop = current.properties[i].propertyId;
                if(prop ===413 )
                {
                  _self.schuhsize = 'E'
                }
                if(prop ===414 )
                {
                  _self.schuhsize = 'F'
                }
                if(prop ===415 )
                {
                  _self.schuhsize = 'G'
                }
                if(prop ===416 )
                {
                  _self.schuhsize = 'H'
                }
                if(prop ===417 )
                {
                  _self.schuhsize = 'J'
                }
                if(prop ===418 )
                {
                  _self.schuhsize = 'K'
                }
                if(prop ===419 )
                {
                  _self.schuhsize = 'L'
                }
                if(prop ===420 )
                {
                  _self.schuhsize = 'M'
                }
              }
            },
            searchVideo()
            {
                let currentVariation = this.currentVariation();
                let _self = this;
                if(currentVariation.hasOwnProperty('variationProperties'))
                {
                    for(let i=0; i < currentVariation.variationProperties.length; i++)
                    {
                        if(currentVariation.variationProperties[i].id == 7)
                        {
                            for(let v=0; v < currentVariation.variationProperties[i].properties.length; v++)
                            {
                                if(currentVariation.variationProperties[i].properties[v].id == 32)
                                {
                                    if(currentVariation.variationProperties[i].properties[v].values.value !="")
                                    {
                                        this.youtubeid = currentVariation.variationProperties[i].properties[v].values.value;
                                    }
                                }
                            }
                        }
                    }
                    return this.youtubeid;
                }
                else
                {
                    return '';
                }
            },
            currentVariation: function()
            {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },
            slideNext() {
                this.$refs.carousel.slideNext();
            },
            slidePrev() {
                this.$refs.carousel.slidePrev();
            }
        },
        computed:
        {
          blackday() {
            const tags = this.magiczoom.tags || [];
            const blackTags = tags.filter(tag => tag.id === 43);
            return { tag: blackTags, active: App.black === '1' };
          },
            variationSelected:function()
            {
              let quantity = this.$store.state.items[`${this.itemId}`].variationOrderQuantity;
              let selected = this.$store.state.items[`${this.itemId}`].variationSelect.isVariationSelected;
              return{
                "quantity": quantity,
                "selected": selected
              }
            },
            magiczoom: function()
            {
                return this.currentVariation();
            },
            ytvideo:function()
            {
                return this.searchVideo();
            }

        }
    }
</script>
